<div class="grid_container">
  <!-- Gabarits des colonnes que le kit ne couvre pas en l'état : format de date exact,
       montant + barre combinés, et la colonne d'actions révélée au survol. -->
  <ng-template #gabaritDate let-row>
    <span appEllipsisTooltip [contrasted]="true">{{ row.date | date: 'dd/MM/yyyy HH:mm' }}</span>
  </ng-template>

  <ng-template #gabaritTotalReverse let-row>
    <div class="progress_bar {{ pourcentageReverse(row) === 100 ? 'barre_ok' : '' }}">
      <div class="progress_bar_montant">
        {{ row.totalReverse | montant }}
        <app-meter [percentage]="pourcentageReverse(row)" ariaLabel="Part déjà reversée" />
      </div>
      <div class="progress_bar_content">{{ pourcentageReverse(row) / 100 | percent }}</div>
    </div>
  </ng-template>

  <!-- Rapprochement : l'original etait une PASTILLE (.caps) et non du texte teinte.
       `app-status-chip` n'acceptant pas d'icone, on reprend ici son gabarit exact
       en remplacant la pastille ronde par l'icone check / croix. Teinte selon les
       TROIS etats du pipe. -->
  <ng-template #gabaritRapprochement let-row>
    <span
      class="inline-flex h-[21px] shrink-0 items-center gap-1 rounded-md px-2 text-[11.5px] font-semibold whitespace-nowrap uppercase"
      [class]="classesRapprochement(row)"
    >
      <app-icon [name]="row.statutRapprochementOk ? 'check' : 'x'" size="xs" aria-hidden="true" />
      {{ row.statutRapprochementOk ? 'ok' : 'ko' }}
    </span>
  </ng-template>

  <!-- EN-TÊTES. `app-table` ne gère pas le tri (le kit réserve `sortable` pour un
       « deferred header-sort seam ») mais expose `headerTemplate`, décrit comme
       « interactive header content » : c'est ce point d'accroche qu'on utilise,
       plutôt que de diverger du kit. Le tri est SERVEUR — l'en-tête émet
       l'intention, le service recharge.

       Un gabarit par colonne : `headerTemplate` est contexte-libre par conception
       du kit, on ne peut donc pas en paramétrer un seul. -->
  <ng-template #enteteNom>
    <app-entete-triable
      libelle="Evènement"
      champ="nom"
      [champActif]="champTri()"
      [sens]="sensTri()"
      (triChange)="trier($event)"
    />
  </ng-template>
  <ng-template #enteteIdAparte>
    <app-entete-triable
      libelle="Id session"
      champ="idAparte"
      [champActif]="champTri()"
      [sens]="sensTri()"
      (triChange)="trier($event)"
    />
  </ng-template>
  <ng-template #enteteDate>
    <app-entete-triable
      libelle="Date & heure"
      champ="date"
      [champActif]="champTri()"
      [sens]="sensTri()"
      (triChange)="trier($event)"
    />
  </ng-template>
  <ng-template #enteteNomClient>
    <app-entete-triable
      libelle="Client"
      champ="nomClient"
      [champActif]="champTri()"
      [sens]="sensTri()"
      (triChange)="trier($event)"
    />
  </ng-template>

  <!-- Infobulles d'aide : rendues APRÈS le texte de l'en-tête, qui reste visible. -->
  <ng-template #enteteMontantTotal>
    <app-entete-info info="Montant total encaissé pour le client" />
  </ng-template>
  <ng-template #enteteTotalReverse>
    <app-entete-info info="Montant total reversé au client + commissions Tick&amp;Live" />
  </ng-template>
  <!-- Clic droit sur une ligne : memes actions que le menu « ⋯ ». -->
  <div (contextmenu)="ouvrirMenuContextuel($event)">
    <app-table
      [rows]="evenements().items"
      [columns]="colonnes()"
      [rowId]="identifiantLigne"
      [status]="statutChargement()"
      emptyMessage="Aucune donnée trouvée"
      (actionClick)="executerAction($event)"
    />
  </div>

  <!-- `hasBackdrop` a false : un second clic droit atteint la ligne visee et y
       reancre le menu d un seul geste. Avec le fond bloquant par defaut, ce
       clic etait intercepte et le navigateur affichait son propre menu. -->
  <app-context-menu
    [position]="positionMenu()"
    [actions]="actionsMenu()"
    ariaLabel="Actions de la ligne"
    [hasBackdrop]="false"
    (actionClick)="executerActionContextuelle($event)"
    (closed)="fermerMenuContextuel()"
  />

  <!-- Le conteneur porte le chrome du pied (barre grise, bordure haute,
       gouttieres) ; le paginateur du kit y est neutralise en SCSS. Voir le bloc
       « PIED DE TABLE » du fichier de styles. -->
  <div
    class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-t border-border-primary bg-surface-secondary px-6 py-3"
  >
    <app-taille-page [taille]="pageFilter().nbrParPage" (tailleChange)="changerTaillePage($event)" />

    <app-pagination-control
      [pageIndex]="pageIndexAffiche() + 1"
      [totalPages]="nombrePages()"
      [totalCount]="evenements().totalCount"
      [pageSize]="pageFilter().nbrParPage"
      (pageChange)="changerPage($event)"
    />
  </div>
</div>
